<template>
    <CardPage :section="13" :page="5">
        <p>Here are the signs you prioritized for healthy relationships:</p>
        <ul class="mb-3">
            <li v-for="(sign, index) in selectedSigns" :key="index">{{ sign.text }}</li>
            <li v-if="mySigns">{{ mySigns }}</li>
        </ul>
        <p>
            Knowing what a healthy relationship looks like is really important, but the question is, do we know how to START and MAINTAIN a healthy
            relationship?
        </p>
        <p>
            In selecting a partner/s, we need to be aware of what we NEED, WANT and DESERVE in a relationship (and this relates to sex as well as other aspects
            of a relationship). I know it can be hard dating as a trans person, but having that set knowledge of your SELF will guide you in the right
            direction. Here’s an example:
        </p>
    </CardPage>
</template>

<script>
import { get } from 'vuex-pathify';
import { filter, values } from 'lodash';

export default {
    computed: {
        signs: get('section13/signs'),
        mySigns: get('section13/mySigns'),
        selectedSigns() {
            return filter(values(this.signs), { selected: true });
        }
    }
};
</script>
